import React, {PureComponent, Fragment} from "react"
import {Reward} from "@irati/types"
import Header from "./Header"
import Description from "./Description"
import DeliveryInfo from "./DeliveryInfo"
import ContactInfo from "./ContactInfo"

interface Props {
  reward: Reward
}

export default class RewardDetail extends PureComponent<Props> {
  render() {
    const {reward} = this.props

    return (
      <Fragment>
        <Header title={reward.header} thumbnailImage={reward.thumbnailImage} />
        <Description description={reward.description} />
        <DeliveryInfo reward={reward} />
        <ContactInfo reward={reward} />
      </Fragment>
    )
  }
}
